import React from 'react';

const ArborescenceLogo = ({ size = 'medium', showText = true }) => {
  const sizes = {
    small: '48px',
    medium: '80px',
    large: '120px'
  };

  const imgHeight = sizes[size];

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <img 
        src="/nvf-logo-official.png" 
        alt="NVF - Naturellement Vert Fertilisation" 
        style={{
          height: imgHeight,
          width: 'auto',
          objectFit: 'contain'
        }}
      />
    </div>
  );
};

export default ArborescenceLogo;
